import Vue from 'vue/dist/vue.esm'

Vue.component('links-quotes-vue',  () => import(/* webpackChunkName: "[request]" */ 'components/links/Quotes.vue'))